














import { changeObjToURLParams } from '../components/utils/util';

import {
  InputValue,
  PROXY_TARGETS,
} from '@internal/plugin-components-react/src/utils/types';
import {
  Method,

  initProxy,
} from '@internal/plugin-components-react/src/api/proxyApi';

/**
 * Options for creating a todo client.
 *
 * @public
 */





/**
 * An implementation of the AgentApi that talks to the agent plugin backend.
 *
 * @public
 */
export class AlertClient  {
    identityApi;
  backendProxy;
  jiraProxy;
  opsgenieProxy;
  method = { method: Method.GET };

  constructor(options) {
    this.identityApi = options.identityApi;
    this.backendProxy = initProxy(PROXY_TARGETS.BACKEND, options.discoveryApi);
    this.jiraProxy = initProxy(PROXY_TARGETS.JIRA, options.discoveryApi);
    this.opsgenieProxy = initProxy(
      PROXY_TARGETS.OPSGENIE,
      options.discoveryApi,
    );
  }

  async getAlertData(
    offset,
    limit,
    startDate,
    endDate,
    searchText,
    tag,
    priority,
    isExact,
  ) {
    const urlQuery = changeObjToURLParams({
      created_at_start_time: startDate,
      created_at_end_time: endDate,
      offset,
      limit,
      ...(searchText && { cluster_id: searchText.replace(/-/g, ':') }),
      ...(tag && { tag }),
      ...(priority && { priority }),
      is_exact_match: isExact,
    });

    try {
      const alert = await this.backendProxy.fetchApi(
        `alertmanagement/v1/alerts/list?${urlQuery}`,
        this.method,
      );
      const data = await alert.json();
      return data;
    } catch (error) {
      return { alerts: [], total: 0, error };
    }
  }

  async getSpecificAlert(id) {
    try {
      const alert = await this.backendProxy.fetchApi(
        `alertmanagement/v1/alerts/${id}`,
        this.method,
      );
      const data = await alert.json();
      if (Object.keys(data).length === 0) throw new Error('No alert found');
      return data;
    } catch (error) {
      throw error;
    }
  }

  async getSubscriptionData(
    tableParams,
    clusterId,
    contactId,
  ) {
    const { limit, offset } = tableParams;
    let params = {
      cluster_id: clusterId,
      ...(contactId && { contact_id: contactId }),
      limit,
      offset,
    };
    const urlQuery = changeObjToURLParams(params);
    try {
      const alert = await this.backendProxy.fetchApi(
        `alertmanagement/v1/subscriptions/list?${urlQuery}`,
        this.method,
      );
      const data = await alert.json();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async addSubscription(
    data,
    env,
  ) {
    const { cluster_name, ...datas } = data;
    const { environment_id } = env;
    const { displayName } = await this.identityApi.getProfileInfo();
    const newSubsc = {
      ...datas,
      cluster_id: environment_id,
      last_updated_timestamp: new Date().toISOString(),
      last_updated_by: displayName ?? '',
      created_timestamp: new Date().toISOString(),
      created_by: displayName ?? '',
    };
    const stringifiedData = JSON.stringify(newSubsc);
    try {
      const alert = await this.backendProxy.fetchApi(
        `alertmanagement/v1/subscriptions/create`,
        { method: Method.POST, body: stringifiedData },
      );
      const data = await alert.json();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async getSpecificSubscription(id) {
    try {
      const alert = await this.backendProxy.fetchApi(
        `/alertmanagement/v1/subscriptions/${id}`,
        this.method,
      );
      const data = await alert.json();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async editSubscription(
    data,
    env,
  ) {
    const { cluster_name, ...datas } = data;
    const { environment_id } = env;

    const { displayName } = await this.identityApi.getProfileInfo();

    const newSubsc = {
      ...datas,
      cluster_id: environment_id,
      last_updated_timestamp: new Date().toISOString(),
      last_updated_by: displayName ?? '',
    };
    const stringifiedData = JSON.stringify(newSubsc);
    const { subscription_id } = newSubsc;
    try {
      await this.backendProxy.fetchApi(
        `/alertmanagement/v1/subscriptions/${subscription_id}`,
        { method: Method.PUT, body: stringifiedData },
      );
      return;
    } catch (error) {
      throw error;
    }
  }

  async deleteSubscription(data) {
    const { subscription_id } = data;
    try {
      await this.backendProxy.fetchApi(
        `alertmanagement/v1/subscriptions/${subscription_id}`,
        {
          method: Method.DELETE,
        },
      );
      return;
    } catch (error) {
      throw error;
    }
  }

  async getEnvironments() {
    try {
      const environment = await this.backendProxy.fetchApi(
        `clustermanagement/v1/environments`,
      );
      const { data } = await environment.json();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async getContactList(params) {
    let urlQuery = '?';

    if (params) {
      const { limit, offset, searchText } = params;
      const query = {
        limit,
        offset,
        ...(searchText && { query: searchText }),
      };
      urlQuery += changeObjToURLParams(query);
    } else urlQuery = '';
    try {
      const contact = await this.backendProxy.fetchApi(
        `alertmanagement/v1/contacts/list${urlQuery}`,
      );
      const data = await contact.json();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async addContact(contact) {
    const { displayName } = await this.identityApi.getProfileInfo();
    const { additional_info } = contact;
    const newData = {
      ...contact,
      additional_info:
        additional_info === InputValue.UNTOUCHED ? '' : additional_info,
      created_by: displayName ?? '',
      last_update_by: displayName ?? '',
      last_updated_timestamp: new Date().toISOString(),
    };
    const body = JSON.stringify(newData);
    try {
      const result = await this.backendProxy.fetchApi(
        'alertmanagement/v1/contacts/create',
        {
          method: Method.POST,
          body,
        },
      );
      const data = await result.json();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async deleteContact(contact) {
    try {
      if (!contact || !contact.contact_id)
        throw new Error('No data or contact id provided');
      await this.backendProxy.fetchApi(
        `alertmanagement/v1/contacts/${contact.contact_id}`,
        {
          method: Method.DELETE,
        },
      );
      return;
    } catch (error) {
      throw error;
    }
  }

  async editContact(contact) {
    const { displayName } = await this.identityApi.getProfileInfo();
    const { contact_id } = contact;
    const data = {
      ...contact,
      last_update_by: displayName ?? '',
      last_updated_timestamp: new Date().toISOString(),
    };
    const body = JSON.stringify(data);
    try {
      await this.backendProxy.fetchApi(
        `alertmanagement/v1/contacts/${contact_id}`,
        {
          method: Method.PUT,
          body,
        },
      );
      return;
    } catch (error) {
      throw error;
    }
  }

  async getOpsgenieData(id) {
    try {
      const opsgenie = await this.opsgenieProxy.fetchApi(
        `v2/alerts/${id}`,
        this.method,
      );
      const opsgenieData = await opsgenie.json();
      return opsgenieData;
    } catch (error) {
      throw error;
    }
  }

  async getJiraData(id) {
    try {
      const jira = await this.jiraProxy.fetchApi(
        `rest/api/3/issue/${id}?fields=*all&fieldsByKeys=false`,
        this.method,
      );
      const data = await jira.json();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async getChartData(
    categorizing,
    startTime,
    endTime,
    priority,
    tagFilter,
    clusterId,
    isExact,
  ) {
    const urlQuery = changeObjToURLParams({
      categorizing,
      created_at_start_time: startTime,
      created_at_end_time: endTime,
      ...(tagFilter && { tag: tagFilter }),
      ...(clusterId && { cluster_id: clusterId.replace(/-/g, ':') }),
      ...(priority && { priority }),
      is_exact_match: isExact,
    });

    try {
      const alert = await this.backendProxy.fetchApi(
        `alertmanagement/v1/alerts/chart?${urlQuery}`,
        this.method,
      );
      const { data } = await alert.json();
      return data;
    } catch (error) {
      throw error;
    }
  }
}
